import { createContext } from 'react';

export const QuoteTypeStoreContext = createContext(null);
